(() => {
  if (window.speakonAgentBannerDismissalReady) return;
  window.speakonAgentBannerDismissalReady = true;
  const key = 'speakon-agent-campaign-dismissed';
  const root = document.documentElement;

  function dismiss() {
    root.setAttribute('data-agent-banner-dismissed', '');
    const sections = new Set();
    document.querySelectorAll('.speakon-agent-banner').forEach(banner => {
      const section = banner.closest('.as-announcement-bar-section');
      if (section) sections.add(section);
      else banner.remove();
    });
    sections.forEach(section => {
      const container = section.querySelector('.as-swiper');
      const swiper = container?.swiper;
      const Swiper = swiper?.constructor;
      const params = { ...swiper?.passedParams };
      // Destroy the old carousel first so loop clones and autoplay timers are removed too.
      swiper?.destroy(true, true);
      section.querySelectorAll('[data-agent-campaign-slide]').forEach(slide => slide.remove());
      const remaining = section.querySelectorAll('.swiper-slide').length;
      if (!remaining) { section.remove(); return; }
      section.querySelector('.as-swiper-slide-count').value = remaining;
      if (remaining === 1) {
        section.querySelector('.as-swiper-navigation-button-wrapper')?.remove();
        section.querySelector('.as-swiper-auto-rotate-time')?.remove();
        section.querySelector('.block-announcement-bar-wrapper')?.classList.add('only-one-slide');
      }
      if (swiper) new Swiper(container, {
        ...params,
        initialSlide: 0,
        loop: remaining > 1 && params.loop,
        autoplay: remaining > 1 ? params.autoplay : false,
        navigation: remaining > 1 ? params.navigation : { enabled: false },
      });
    });
  }

  function restore() {
    let dismissed = root.hasAttribute('data-agent-banner-dismissed');
    try { dismissed ||= localStorage.getItem(key) === '1'; } catch { /* Closing still works without storage. */ }
    if (dismissed) dismiss();
  }

  document.addEventListener('click', event => {
    if (!event.target.closest?.('[data-agent-banner-close]')) return;
    event.preventDefault();
    event.stopPropagation();
    try { localStorage.setItem(key, '1'); } catch { /* Keep the current-page dismissal even if persistence is blocked. */ }
    dismiss();
    document.querySelector('.speakon-header a[href]')?.focus({ preventScroll: true });
  });
  document.addEventListener('shopify:section:load', restore);
  window.addEventListener('storage', event => {
    if (event.key === key && event.newValue === '1') dismiss();
  });
  restore();
})();
